import ServiceTel from './service-tel'
export default ServiceTel
